import { lazy } from "react";

const CHUNK_RECOVERY_KEY = "manucalc_chunk_recovered";
const CHUNK_LOAD_TIMEOUT_MS = 12000;

const withChunkTimeout = (promise) =>
  Promise.race([
    promise,
    new Promise((_, reject) => {
      window.setTimeout(() => {
        const error = new Error(`Route chunk load timed out after ${CHUNK_LOAD_TIMEOUT_MS}ms`);
        error.name = "ChunkLoadError";
        reject(error);
      }, CHUNK_LOAD_TIMEOUT_MS);
    }),
  ]);

const lazyWithChunkRecovery = (importer) =>
  lazy(() =>
    withChunkTimeout(importer())
      .then((module) => {
        if (typeof window !== "undefined") {
          window.sessionStorage.removeItem(CHUNK_RECOVERY_KEY);
        }
        return module;
      })
      .catch((error) => {
        const message = String(error?.message || error || "");
        const isChunkError =
          error?.name === "ChunkLoadError" ||
          message.includes("Loading chunk") ||
          message.includes("Failed to fetch dynamically imported module");

        if (
          isChunkError &&
          typeof window !== "undefined" &&
          window.sessionStorage.getItem(CHUNK_RECOVERY_KEY) !== "true"
        ) {
          window.sessionStorage.setItem(CHUNK_RECOVERY_KEY, "true");
          window.location.reload();
        }

        throw error;
      })
  );

export default lazyWithChunkRecovery;
